<template>
  <!-- <div class="root d-inline-block">
    <button
      v-if="params.mode === 'create'"
      class="btn btn-success"
      @click="openModal"
  >{{ modalButtonName }}</button>-->
  <b-modal
    ref="modal"
    id="modal-center"
    centered
    size="lg"
    :title="modalTitle"
    :ok-title="'ذخیره'"
    :hide-footer="params.mode === 'view'"
    :cancel-title="'لغو'"
    @ok="onModalOk"
  >
    <div class="row">
      <div class="col-4">
        <div class="input-group mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام بانک</span>
            </div>
          </div>
          <input
            v-if="params.mode==='view'"
            readonly="readonly"
            v-model="selectedBank.name"
            type="text"
            class="form-control"
          >
          <vs-select
            v-if="params.mode!=='view'"
            ref="bankName"
            style="width:64%;"
            :isHeader="true"
            :data="banksModel"
            :selectedVal="selectedBank"
            :header="{label:'name'}"
            :mode="'edit'"
            @dataChanged="selectBank"
            tabindex="1"
          ></vs-select>
          <!-- <input :disabled="params.mode === 'view'" v-model="account.name" type="number" onkeydown="return event.keyCode !== 69" class="form-control"> -->
        </div>
      </div>
      <div class="col-4">
        <div class="input-group mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام شعبه</span>
            </div>
          </div>
          <input
            :disabled="params.mode === 'view'"
            v-model="account.branchName"
            type="text"
            class="form-control"
            tabindex="2"
          >
        </div>
      </div>
      <div class="col-4">
        <div class="input-group mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>کد شعبه</span>
            </div>
          </div>
          <input
            :disabled="params.mode === 'view'"
            v-model="account.branchCode"
            type="number"
            onkeydown="return event.keyCode !== 69"
            class="form-control"
            tabindex="3"
          >
        </div>
      </div>
      <div class="col-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>شماره حساب</span>
            </div>
          </div>
          <input
            :disabled="params.mode === 'view'"
            v-model="account.number"
            type="text"
            class="form-control"
            tabindex="4"
          >
        </div>
      </div>

      <div class="col-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نوع حساب</span>
            </div>
          </div>
          <input
            v-if="params.mode==='view'"
            readonly="readonly"
            v-model="selectedAccountType.type"
            type="text"
            class="form-control"
          >
          <vs-select
            v-if="params.mode!=='view'"
            ref="accountType"
            style="width:64%;"
            :isHeader="true"
            :data="[{name:'جاری',code:1},{name:'پس انداز',code:2},{name:'کوتاه مدت',code:3},{name:'بلند مدت',code:4},{name:'کوتاه مدت ویژه',code:5}]"
            :selectedVal="selectedAccountType"
            :header="{label:'name'}"
            :mode="'edit'"
            @dataChanged="selectAccountType"
            tabindex="5"
          ></vs-select>
        </div>
      </div>
      <div class="col-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>شماره شبا</span>
            </div>
          </div>
          <input
            :disabled="params.mode === 'view'"
            v-model="account.shebaCode"
            type="number"
            onkeydown="return event.keyCode !== 69"
            class="form-control"
            tabindex="6"
          >
        </div>
      </div>
      <div class="col-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>شماره کارت</span>
            </div>
          </div>
          <input
            :disabled="params.mode === 'view'"
            v-model="account.kartNumber"
            type="number"
            onkeydown="return event.keyCode !== 69"
            class="form-control"
            tabindex="7"
          >
        </div>
      </div>
    </div>
  </b-modal>
  <!-- </div> -->
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import BaseService from "../_framework/api/BaseService.js";
import Utils from "../_framework/utils/Utils.js";
import VsSelect from "../_framework/VsSelect";
import VsTableMixin from "../_framework/VsTableMixin.js";
import EventBus from "../bus.js";

export default {
  name: "bank-accounts-modal-button",
  props: {
    account: {
      default() {
        return {

          bankId: 0,
         code: "1",
          branchCode: "",
          branchName: "",
          type: 0,
          number: "",
          kartNumber: "",
          shebaCode: ""
        };
      },
      type: Object
    },
    mode: "view",
    params: {
      mode: "view"
    },
    entity: "",
    entityDisplayName: {
      default: "حساب بانکی",
      type: String
    }
  },
  mixins: [VsTableMixin],
  components: {
    VsSelect
  },
  data() {
    return {
      banksModel: null,
      bankName: "",
      selectedBank: '',
      selectedAccountType: null
    };
  },
  mounted() {
    if (this.params.mode === "edit" || this.params.mode === "view") {
      if (this.account) {
        if (this.account.bank) {
          this.selectedBank = this.account.bank;
        }
        if (this.account.accountType) {
          //{name:'جاری',code:1},{name:'پس انداز',code:2},{name:'کوتاه مدت',code:3},{name:'بلند مدت',code:4},{name:'کوتاه مدت ویژه',code:5}
          switch (this.account.accountType) {
            case 1:
              this.selectedAccountType = { name: "جاری", code: 1 };
              break;
            case 2:
              this.selectedAccountType = { name: "پس انداز", code: 2 };
              break;
            case 3:
              this.selectedAccountType = { name: "کوتاه مدت", code: 3 };
              break;
            case 4:
              this.selectedAccountType = { name: "بلند مدت", code: 4 };
              break;
            case 5:
              this.selectedAccountType = { name: "کوتاه مدت ویژه", code: 5 };
              break;
            default:
              break;
          }
        }
      }
    }
    new BaseService("banks").getAll().then(rs => {
      this.banksModel = rs.data;
    });
  },
  methods: {
    openModal() {
      this.$refs.modal.show();
    },
    selectBank(prop, data) {
      this.account.bankId = data.id;
    },
    selectAccountType(prop, data) {
      this.account.type = data.code;

    },
    onModalOk(e) {
      e.preventDefault();
      if (this.params.mode === "create") {
        this.onCreate();
      } else if (this.params.mode === "edit") {
        this.onUpdate();
      }
      EventBus.$emit("bankAccountChanged");
    },
    onCreate() {
      new BaseService("accounts")
        .create(this.account)
        .then(response => {
          this.$noty.success("موفقیت آمیز.");
          this.$refs.modal.hide();
          setTimeout(() => {
            this.resetModel();
          }, 500);
        });
        // .catch(error => {
        //   // error
        //   Utils.handleErrorWithNotification(error.data.message, this.$noty);
        // });
    },
    onUpdate() {
      new BaseService("accounts")
        .update(this.account)
        .then(response => {
          this.$noty.success("موفقیت آمیز.");
          this.$refs.modal.hide();
        });
        // .catch(error => {
        //   // error
        //   Utils.handleErrorWithNotification(error.data.message, this.$noty);
        // });
    },
    resetModel() {
      Utils.resetObject(this.account);
      this.account.id = 0;
    }
  },
  computed: {
    ...mapState(["selectedRows", "currentService"]),
    modalButtonName() {
      return (
        (this.params.mode === "create" ? "ایجاد" : "ویرایش") +
        " " +
        this.entityDisplayName +
        " "
      );
    },
    modalTitle() {
      switch (this.params.mode) {
        case "view":
          return "مشاهده جزییات " + this.entityDisplayName;
        case "create":
          return "ایجاد " + this.entityDisplayName;
        case "edit":
          return "ویرایش " + this.entityDisplayName;
        default:
          return "";
      }
    }
  },
  watch: {}
};
</script>

<style scoped>
hr {
  background-color: rgba(255, 255, 255, 0.4);
}
</style>
